import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=61d46943&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d46943')) {
      api.createRecord('61d46943', component.options)
    } else {
      api.reload('61d46943', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=61d46943&", function () {
      api.rerender('61d46943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-resources/Navigation.vue"
export default component.exports